import { JstDate } from '../../core/time/business-time';
const DEFAULT_CREATE_TRANSACTION_DAY = 11;

export function isSubscriptionRequest(notification: any): boolean {
  const type = Number(notification?.requestTypeId ?? notification?.requestType?.id ?? notification?.requestType);
  return type === 10 || type === 11;
}

export function canProcessNotificationRequest(notification: any, dayOfCreateTransaction: number): boolean {
  return isSubscriptionRequest(notification) || isBeforeNotificationDeadline(notification, dayOfCreateTransaction);
}

export function resolveCreateTransactionDay(schedule: any): number {
  const value = typeof schedule === 'number' ? schedule : schedule?.createTransaction;
  const day = Number(value);
  return Number.isFinite(day) && day > 0 ? day : DEFAULT_CREATE_TRANSACTION_DAY;
}

export function isBeforeNotificationDeadline(
  notification: any,
  dayOfCreateTransaction: number,
  nowValue?: Date | string | number,
): boolean {
  const now = nowValue ? new JstDate(nowValue) : new JstDate();
  let processingDate: Date;

  if (!notification?.startDate && notification?.endDate) {
    const endDate = new JstDate(notification.endDate);
    processingDate = new JstDate(endDate.getFullYear(), endDate.getMonth() + 1, 1);
  } else {
    const startDate = new JstDate(notification?.startDate);
    processingDate = new JstDate(startDate.getFullYear(), startDate.getMonth(), 1);
  }

  if (Number.isNaN(processingDate.getTime())) return false;
  if (now.getDate() < dayOfCreateTransaction) return now < processingDate;

  const processingDateOneAfterAnother = new JstDate(now.getFullYear(), now.getMonth() + 2, 1);
  return processingDateOneAfterAnother <= processingDate;
}

export function canRemoveNotificationRequest(notification: any, dayOfCreateTransaction: number): boolean {
  if (Number(notification?.status) === 2) {
    return isBeforeNotificationDeadline(notification, dayOfCreateTransaction);
  }
  return true;
}

export function isEditableBeforePlan(notification: any, dayOfCreateTransaction: number): boolean {
  if (Number(notification?.status) !== 0 && Number(notification?.status) !== 2) return false;

  const endDate = new JstDate(notification?.endDate);
  if (Number.isNaN(endDate.getTime())) return false;

  const now = new JstDate();
  if (now.getDate() < dayOfCreateTransaction) return now < endDate;

  return new JstDate(now.getFullYear(), now.getMonth() + 1, 1) <= endDate;
}
